(() => {
  if (customElements.get('ori-chatbot')) return;
  customElements.define('ori-chatbot', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const launcher = this.querySelector('[data-launcher]');
      const panel = this.querySelector('[data-panel]');
      const questions = this.querySelector('[data-questions]');
      const answer = this.querySelector('.ori-chat__answer');
      const reset = this.querySelector('[data-reset]');
      const close = this.querySelector('[data-close]');
      const whatsapp = this.querySelector('[data-whatsapp]');
      const number = (this.dataset.number || '').replace(/[^0-9]/g, '');
      const validNumber = /^[1-9][0-9]{7,14}$/.test(number);
      const setLink = (question = '') => {
        if (!whatsapp || !validNumber) return;
        const message = `Hi ORI! ${question ? `I would like to know more: ${question}` : 'I would like some help choosing a piece.'}`;
        whatsapp.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
      };
      if (whatsapp) whatsapp.hidden = !validNumber;
      setLink();
      const toggle = (open) => {
        panel.hidden = !open;
        launcher.setAttribute('aria-expanded', String(open));
        (open ? close : launcher).focus();
      };
      launcher.addEventListener('click', () => toggle(panel.hidden));
      close.addEventListener('click', () => toggle(false));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.preventDefault();
          toggle(false);
        }
      });
      questions.addEventListener('click', (event) => {
        const button = event.target.closest('[data-question]');
        if (!button) return;
        answer.replaceChildren();
        const heading = document.createElement('strong');
        heading.textContent = button.textContent;
        const text = document.createElement('p');
        text.textContent = button.dataset.answer;
        answer.append(heading, text);
        questions.hidden = true;
        reset.hidden = false;
        setLink(button.textContent.trim());
        reset.focus();
      });
      reset.addEventListener('click', () => {
        answer.replaceChildren();
        questions.hidden = false;
        reset.hidden = true;
        setLink();
        questions.querySelector('button')?.focus();
      });
      launcher.hidden = false;
    }
  });
})();
